module.exports = __webpack_public_path__ + "static/media/college-students-03.3628615d.jpg";